<template>
<v-dialog v-model="dialog" max-width="1376" scrollable persistent>
    <v-card class="rounded-xl">
        <v-card-title class="card-title-background-detail py-4 ">
          <v-row class="row-db" align="center">
            <v-spacer></v-spacer>
              <b class="front-hc">HC Dashboard Detail</b>
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false,optionsTransaction.page = 1"  color="#ffffff">
              <v-icon>
                mdi-close
              </v-icon> 
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text class="px-4">
            <v-row class="row-db">  
                <v-col cols="auto" md="auto" lg="auto" class="px-0 pt-4 pb-0 mb-4" align-self="center">
                    <b class="front-text-hc">ตารางแสดงรายการ</b>
                </v-col>
                <v-col cols="6" md="auto" lg="auto" align-self="center" class="py-0 pr-2">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="#1DBC97"
                            :disabled="is_on_job"
                            @click="checkWaitSync"
                            >
                            <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>Refresh ข้อมูล</span>
                    </v-tooltip>
                </v-col>
                <v-col v-show="!is_on_job" cols="auto" md="auto" lg="auto" align-self="center" class="py-0 pl-0">
                    <span class="front-text-date-detail">อัพเดทล่าสุดเมื่อ: {{sync_date_time}}</span>
                </v-col>
                <v-col v-show="is_on_job" cols="auto" md="auto" lg="auto" align-self="center" class="py-0 pl-0">
                    <span class="front-text-date-detail">กำลังอัพเดทข้อมูล...</span>
                </v-col>
                <v-col cols="auto" md="auto" lg="auto" class="pr-0 pt-4 pb-0 mb-4 pl-1" align-self="center">
                    <b v-if="data == 'decline' " class="text-hc-content">ปฏิเสธรับเงิน</b>
                    <b v-else-if="data == 'cancel'" class="text-hc-content">Status Cancel</b>
                    <b v-else-if="data == 'reject'" class="text-hc-content">Status Reject</b>
                    <b v-else-if="data == 'accept'" class="text-hc-content">ยืนยันการรับเงิน</b>
                    <b v-else-if="data == 'paid'" class="text-hc-already-pay">จ่ายแล้ว</b>
                    <b v-else-if="data == 'approved'" class="text-hc-content">อนุมัติเสร็จสิ้น</b>
                </v-col>             
                <v-col v-if="data == 'paid'" cols="12" md="auto" lg="auto" align-self="center" class="pa-0"> <!-- card ของ status จ่ายแล้ว -->
                    <v-row align="center" class="row-db">
                        <v-col cols="6" md="auto" lg="auto" align-self="center" class="pl-0 pr-3 py-0 status-color-card-block">
                            <v-card outlined color="#CACACA" class="pa-1 status-color-card">
                                <v-row align="center" class="row-db">
                                    <v-avatar color="white" size="27" class="status-color-icon-block">
                                        <v-icon color="#3FBC3F" size="22">mdi-clock-time-three-outline</v-icon>
                                    </v-avatar>
                                    <b class="mx-3 status-color-green-value">{{status_green}} <span class="black_color">|</span> {{Percen_green}}%</b>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="6" md="auto" lg="auto" align-self="center" class="pl-3 pr-0 py-0">
                            <v-card outlined color="#CACACA" class="pa-1 status-color-card">
                                <v-row align="center" class="row-db">
                                    <v-avatar color="white" size="27" class="status-color-icon-block">
                                        <v-icon color="#FEA322" size="22">mdi-timer-outline</v-icon>
                                    </v-avatar>
                                    <b class="mx-3 status-color-yellow-value">{{status_yellow}} <span class="black_color">|</span> {{Percen_yellow}}%</b>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="auto" lg="auto" align-self="center" class="pr-0 pb-0 status-red-card-block">
                            <v-card outlined color="#CACACA" class="pa-1 status-color-card">
                                <v-row align="center" class="row-db">
                                    <v-avatar color="white" size="27" class="status-color-icon-block">
                                        <v-icon color="#FF0000" size="22">mdi-alarm</v-icon>
                                    </v-avatar>
                                    <b class="mx-3 status-color-red-value">{{status_red}} <span class="black_color">|</span> {{Percen_red}}%</b>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="3" lg="3" class=" pb-0 px-0 pt-4 between-hc" >
                    <v-text-field
                    outlined
                    hide-details 
                    dense
                    v-model="search"
                    label="ค้นหารายการอนุมัติ"
                    placeholder="ค้นหารายการอนุมัติ"
                    prepend-inner-icon="mdi-magnify"
                    class="search-box-hc"
                    color="#1DBC97"
                    background-color="white"
                    @keydown.enter="submit"
                    ></v-text-field>
                </v-col>
               <!-- Temp Comment -->
                <v-col cols="auto" md="auto" lg="auto" align-self="center" class=" pb-0 pr-0 pl-2 pt-4 mb-4 between-btn">
                    <v-menu ref=menuDateExportInModal v-model="export_date.menu" :close-on-content-click="false" :return-value.sync="export_date.dateValue">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn height="40px" outlined color="#1DBC97" class="btn-export-excel" v-bind="attrs" v-on="on">
                                <v-icon left  small>
                                mdi-download
                                </v-icon>
                                export excel
                            </v-btn>
                        </template>
                        <v-date-picker v-model="export_date.dateValue" range no-title show-current :max="max_date" :min="min_date" color="#1DBC97">
                            <v-spacer></v-spacer>
                            <v-btn height="32" outlined color="#1DBC97" class="rounded-lg font-cleacon-hcdash" @click="export_date.menu = false">
                            Clear
                            </v-btn>
                            <v-btn height="32" :disabled="export_date.dateValue.length < 2" depressed color="#1DBC97" class="white--text rounded-lg font-cleacon-hcdash" @click="$refs.menuDateExportInModal.save(export_date.dateValue),exportHcDashboard()">
                            Export
                            </v-btn>
                        </v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
                <v-data-table class="hc-data-table hc-data-table-border hc-data-table-header hide-hc-table-progress hc-data-table-table"
                fixed-header
                :loading="load"
                :headers="hc_data_table_headers"
                :items="hcReportData"
                :search="search"
                :options.sync="optionsTransaction"
                :server-items-length="total_status"
                :footer-props="{'items-per-page-options': [5, 10, 15]}"
                >
                <template v-slot:loading>
                <!-- loading data in table -->

                <v-row
                  align="center"
                  justify="center"
                  class="report-row report-dashboard-loading-block"
                >
                <v-progress-circular indeterminate color="#1DBC97"></v-progress-circular>
                </v-row>
                </template>
                <template v-slot:[`item.performance_status`]="{ item }">
                <span v-if="item.performance_status == 'green'" class="data-status-normal">Normal</span>  
                <span v-else-if="item.performance_status == 'yellow'" class="data-status-moniter">Monitor</span>     
                <span v-else-if="item.performance_status == 'red'" class="data-status-alert">Alert</span>
                <span v-else-if="item.performance_status == 'prepare'" >Prepare</span>
                <span v-else-if="item.performance_status == 'review'" >Review</span>
                <span v-else-if="item.performance_status == 'reject'" >Reject</span>
                <span v-else-if="item.performance_status == 'cancel'" >Cancel</span>
                <span v-else-if="item.performance_status == 'approved'" >Approved</span>
                <span v-else-if="item.performance_status == 'จ่ายแล้ว'" >จ่ายแล้ว</span>
                <span v-else-if="item.performance_status == 'ยืนยันรับเงิน'" >ยืนยันรับเงิน</span>
                <span v-else-if="item.performance_status == 'ปฏิเสธรับเงิน'" >ปฏิเสธรับเงิน</span>
                </template>
                <template v-slot:[`item.resend`]= "{ item }">
                    <v-btn outlined height="28px" color="#219653" class="btn-resubmit" @click="resend(item.transaction_id)">ส่งใหม่อีกครั้ง</v-btn>
                </template>

                </v-data-table>
        </v-card-text>
    </v-card>
</v-dialog>
</template>


<script>
import { EventBus } from '../../EventBus'
import moment from 'moment'
    export default {
        data: ()=> ({
            dialog: false,
            load:false,
            data:'',
            search:'',
            hcReportData: [],
            optionsTransaction: {
                page:1,
                itemsPerPage: 10
            },
            trigger_rowPerPage:false,
            total_status: 0,
            page_all_document : false,
            page_waiting: true,
            click_resend:false,
            status_green:0,
            status_red:0,
            status_yellow:0,
            Percen_red : 0,
            Percen_green : 0,
            Percen_yellow : 0,
            export_date: {
                menu: false,
                dateValue: [],
                length_date_day: 45
            },
            currentdate: new Date().toISOString().substr(0, 10),
            sync_date_time: "",
            is_on_job: false,
            date : []
        }),
        //---------------------------- Computed ----------------------------//
        computed:{
            hc_data_table_headers() {
                if(this.data === 'cancel' || this.data === 'reject' || this.data === 'accept' || this.data === 'paid' || this.data === 'wait_paid' || this.data === 'approved'){
                    return [
                        {text: 'วันที่สร้างเอกสาร',align:'center', sortable: false, value: 'show_date'},
                        {text: 'บริษัท',     align:'center', sortable:false,   value: 'biz_name'},
                        {text: 'เลขที่เอกสาร',   align:'start',  sortable:false,  value: 'document_id' },
                        {text: 'ชื่อผู้ส่งเอกสาร',  align:'start',  sortable:false , value: 'sender_name'},
                        {text: 'จำนวนเงิน',     align:'end',    sortable:false,  value: 'total_amount'},
                        // {text: 'ลำดับที่รออนุมัติ', align:'center', sortable:false, value: 'step'},
                        // {text: 'ชื่อผู้อนุมัติ',     align:'start', sortable:true,   value: 'approver'},
                        {text: 'วันที่ดำเนินการเสร็จสิ้น',     align:'center', sortable:false,   value: 'last_date'},
                        {text: 'Performance status', align:'center', sortable:false, value: 'performance_status'},
                        {text: 'Status',     align:'center', sortable:false,   value: 'document_status'}
                    ]
                }else if(this.data === 'decline'){
                    return [
                        {text: 'วันที่สร้างเอกสาร',align:'center', sortable: false, value: 'show_date'},
                        {text: 'เลขที่เอกสาร',   align:'start',  sortable:false,  value: 'document_id' },
                        {text: 'ชื่อผู้ส่งเอกสาร',  align:'start',  sortable:false , value: 'sender_name'},
                        {text: 'จำนวนเงิน',     align:'end',    sortable:false,  value: 'total_amount'},
                        // {text: 'ลำดับที่รออนุมัติ', align:'center', sortable:false, value: 'step'},
                        // {text: 'ชื่อผู้อนุมัติ',     align:'start', sortable:true,   value: 'approver'},
                        {text: 'วันที่ดำเนินการเสร็จสิ้น',     align:'center', sortable:false,   value: 'last_date'},
                        {text: 'Performance status', align:'center', sortable:false, value: 'performance_status'},
                        {text: 'Status',     align:'center', sortable:false,   value: 'document_status'},
                        {text: 'Resend ',     align:'center', sortable:false,   value: 'resend'},
                    ]
                }else if(this.data === 'prepare' || this.data === 'review' ){
                    return [
                        {text: 'วันที่สร้างเอกสาร',align:'center', sortable: false, value: 'show_date'},
                        {text: 'บริษัท',     align:'center', sortable:false,   value: 'biz_name'},
                        {text: 'เลขที่เอกสาร',   align:'start',  sortable:false,  value: 'document_id' },
                        {text: 'ชื่อผู้ส่งเอกสาร',  align:'start',  sortable:false , value: 'sender_name'},
                        {text: 'จำนวนเงิน',     align:'end',    sortable:false,  value: 'total_amount'},
                        {text: 'ลำดับที่รออนุมัติ', align:'center', sortable:false, value: 'step'},
                        {text: 'ชื่อผู้อนุมัติ',     align:'start', sortable:false,   value: 'approver'},
                        {text: 'ระยะเวลารออนุมัติ',     align:'start', sortable:false,   value: 'wait_duration'},
                        {text: 'วันที่ดำเนินการเสร็จสิ้น',     align:'center', sortable:false,   value: 'last_date'},
                        {text: 'Performance status', align:'center', sortable:false, value: 'performance_status'},
                        {text: 'Status',     align:'center', sortable:false,   value: 'document_status'}
                    ]
                }
                else{
                    return [
                        {text: 'วันที่สร้างเอกสาร',align:'center', sortable: false, value: 'show_date'},
                        {text: 'บริษัท',     align:'center', sortable:false,   value: 'biz_name'},
                        {text: 'เลขที่เอกสาร',   align:'start',  sortable:false,  value: 'document_id' },
                        {text: 'ชื่อผู้ส่งเอกสาร',  align:'start',  sortable:false , value: 'sender_name'},
                        {text: 'จำนวนเงิน',     align:'end',    sortable:false,  value: 'total_amount'},
                        {text: 'ลำดับที่รออนุมัติ', align:'center', sortable:false, value: 'step'},
                        {text: 'ชื่อผู้อนุมัติ',     align:'start', sortable:false,   value: 'approver'},
                        {text: 'Performance status', align:'center', sortable:false, value: 'performance_status'}
                    ]
                }
            },
            max_date() {
                if(!this.export_date.dateValue.at(0)) return this.currentdate
                const date_selected = new Date(this.export_date.dateValue.at(0))
                date_selected.setDate(date_selected.getDate() + this.export_date.length_date_day);
                const moreCurrentDate = date_selected > new Date(this.currentdate) ? this.currentdate : `${date_selected.getFullYear()}-${(date_selected.getMonth() + 1).toString().padStart(2, '0')}-${(date_selected.getDate()).toString().padStart(2, '0')}`
                return moreCurrentDate
            },
            min_date() {
                if(!this.export_date.dateValue.at(0)) return null
                const date_selected = new Date(this.export_date.dateValue.at(0))
                date_selected.setDate(date_selected.getDate() - this.export_date.length_date_day);
                return `${date_selected.getFullYear()}-${(date_selected.getMonth() + 1).toString().padStart(2, '0')}-${(date_selected.getDate()).toString().padStart(2, '0')}`
            }
        },
        //---------------------------- Watch ----------------------------//
        watch:{
            "optionsTransaction.page"(newValue,oldValue){
                if (newValue )
                    if(this.page_all_document && this.page_waiting){
                        //console.log("mark");
                        this.getReportItem_Alldoc({page:newValue}).then(data => {})
                        this.trigger_rowPerPage = true    
                    }else{
                        this.getReportItem({page:newValue}).then(data => {})
                        this.trigger_rowPerPage = true
                    }
                },
            "optionsTransaction.itemsPerPage"(newValue,oldValue){
                if (this.trigger_rowPerPage == false) {
                    if(this.page_all_document && this.page_waiting){
                        this.optionsTransaction.page = 1
                        this.getReportItem_Alldoc({page:1, itemsPerPage:newValue}).then(data => {})
                    }else{
                        this.optionsTransaction.page = 1
                        this.getReportItem({page:1, itemsPerPage:newValue}).then(data => {})
                    }
                }
            },
            dialog(value){
                //console.log(value);
                this.status_green = 0
                this.status_red = 0 
                this.status_yellow = 0 
                if(value){
                    this.click_resend = false
                }else{
                    if(this.click_resend == true){
                        this.$emit('RefreshAllDoc')
                        this.$emit('RefreshWPS')
                    }
                }
            },
            'export_date.menu'(val) {
                if(val) this.export_date.dateValue = []
            }
        },
        //---------------------------- Mounted ----------------------------//
        mounted() {
            EventBus.$on('formhcdashboarddetailmodal',this.getHCDashboardDetailModal)
            this.checkWaitSyncStatus()
        },
        //---------------------------- Methods ----------------------------//
        methods: {
            getHCDashboardDetailModal(chekItem,count,page_all_doc,date){
                this.dialog = true
                this.total_status = count
                this.data = chekItem
                this.optionsTransaction.page = 1
                this.page_all_document = page_all_doc
                this.date = date
 
                //----- เช็คเงื่อนไขระหว่างAPI ==> Waiting Performance Status กับ All Document -----//
                if( this.page_all_document && this.page_waiting){
                    this.getReportItem_Alldoc()  
                    this.checkstatusPaid() 
                }else{
                    this.getReportItem()
                }
                
                
            },
            //----- getReportItem ==> เรียกใช้มาแสดงข้อมูลในตาราง Waiting Performance Status ----//
            async getReportItem(filter = {}) {
                const { page, itemsPerPage} = {
                    page: this.optionsTransaction.page,
                    itemsPerPage: this.optionsTransaction.itemsPerPage,
                    ...filter
                }
                this.hcReportData = []
                this.load = true
                try{
                    //var tax_id = sessionStorage.getItem('tax_id')
                    var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
                    var url = '/petty_cash/api/v1/get_hc_remaining'
                    var { data } = await this.axios.post(this.$api_url + url, {
                        status: this.data,
                        tax_id:tax_id,
                        keyword:this.search,
                        limit: itemsPerPage, 
                        offset: (page-1)*itemsPerPage || 0,
                        start_date:this.date[0],
                        end_date:this.date[1],
                    })
                    if(data){
                        //console.log("Data:",data);
                        data.result.forEach(element => {
                            element['show_date'] = `${element.date.split('-')[2]}/${element.date.split('-')[1]}/${element.date.split('-')[0]}`
                            this.hcReportData.push(element)
                        })
                    }
                }catch(error){
                    console.log(error)
                }
                finally{
                    this.load = false
                }
            },
            //----- getReportItem_Alldoc ==> เรียกใช้มาแสดงข้อมูลในตาราง All Document ----//
            async getReportItem_Alldoc(filter = {}) {
                if(this.dialog == false){
                    return 
                }
                const { page, itemsPerPage} = {
                    page: this.optionsTransaction.page,
                    itemsPerPage: this.optionsTransaction.itemsPerPage,
                    ...filter
                }
                this.hcReportData = []
                this.load = true
                try{
                    //var tax_id = sessionStorage.getItem('tax_id')
                    var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
                    var url = '/petty_cash/api/v1/count_hc_status'
                    var { data } = await this.axios.post(this.$api_url + url, {
                        status: this.data,
                        tax_id:tax_id,
                        keyword:this.search,
                        limit: itemsPerPage, 
                        offset: (page-1)*itemsPerPage || 0,
                        start_date:this.date[0],
                        end_date:this.date[1],
                    })
                    if(data){
                        data.result.forEach(element => {
                            element['show_date'] = `${element.date.split('-')[2]}/${element.date.split('-')[1]}/${element.date.split('-')[0]}`
                            if(element.last_step_at) {
                                element['last_date'] = `${element.last_step_at.substring(0,10).split('-')[2]}/${element.last_step_at.substring(0,10).split('-')[1]}/${element.last_step_at.substring(0,10).split('-')[0]}`
                                let waitTime = new Date().getTime() - new Date(element.last_step_at).getTime()
                                element['wait_duration'] = `${this.convertMilliseconds(waitTime)}`
                            }
                            this.hcReportData.push(element)
                        })
                    }  
                }catch(error){
                    console.log(error)
                }
                finally{
                    this.load = false
                    this.trigger_rowPerPage = false
                }
            },
            convertMilliseconds(ms) {
                let msPerMinute = 1000 * 60;
                let msPerHour = msPerMinute * 60;
                let msPerDay = msPerHour * 24;
                let msPerMonth = msPerDay * 30.44; // Average month length

                let months = Math.floor(ms / msPerMonth);
                ms %= msPerMonth;
                let days = Math.floor(ms / msPerDay);
                ms %= msPerDay;
                let hours = Math.floor(ms / msPerHour);
                ms %= msPerHour;
                let minutes = Math.floor(ms / msPerMinute);
                let resText = ""
                if(months) {
                    resText += `${months} เดือน`
                }
                if(days) {
                    resText += `${days} วัน`
                }
                if(hours) {
                    resText += `${hours} ชั่วโมง`
                }
                if(minutes) {
                    resText += `${minutes} นาที`
                }
                return resText
            },
            //----- numberToComma ==> ถูกเรียกใช้ในฟังก์ชั่น getReportItem,getReportItem_Alldoc ----//
            numberToComma(num) {
                if (num) {
                    var sp_num = String(num).split(".")
                    var decimal = "";
                    sp_num[1] ? (decimal = sp_num[1]) : (decimal = "")
                    num = sp_num[0];
                    var commaNum = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    decimal != "" ? (commaNum += "." + decimal) : (commaNum = commaNum)
                    return commaNum
                } else {
                    return num
                }
            },
            // ----- exportHcDashboard ==> เรียกใช้ Export Excel ----//
            async exportHcDashboard(){
                const allDate = this.export_date.dateValue.map(item => new Date(item))
                let start_date = null
                let end_date = null
                if(allDate[0] > allDate[1]) {
                    start_date = `${allDate[1].getFullYear()}-${(allDate[1].getMonth() + 1).toString().padStart(2, '0')}-${(allDate[1].getDate()).toString().padStart(2, '0')}`
                    end_date = `${allDate[0].getFullYear()}-${(allDate[0].getMonth() + 1).toString().padStart(2, '0')}-${(allDate[0].getDate()).toString().padStart(2, '0')}`
                } else {
                    end_date = `${allDate[1].getFullYear()}-${(allDate[1].getMonth() + 1).toString().padStart(2, '0')}-${(allDate[1].getDate()).toString().padStart(2, '0')}`
                    start_date = `${allDate[0].getFullYear()}-${(allDate[0].getMonth() + 1).toString().padStart(2, '0')}-${(allDate[0].getDate()).toString().padStart(2, '0')}`
                }
                if( this.page_all_document && this.page_waiting){
                    try{
                        //var tax_id = sessionStorage.getItem('tax_id')
                        var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
                        var url = '/petty_cash/api/v1/export_report_hcstatus'
                        let form = {
                            status:this.data,
                            tax_id:tax_id,
                            start_date,
                            end_date
                            }
                        var  data  = await this.axios.post(this.$api_url  + url, form, {responseType:"blob"})
                        .then( response  =>{
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement("a");
                            let namefile = `Status Report ${moment().locale('th').add(543, 'year').format('DD MMMM YYYY h_mm_ss')}.xlsx`
                            link.href = url;
                            link.setAttribute("download", namefile);
                            document.body.appendChild(link);
                            link.click();
                        })
                    }
                    catch(err){
                        console.log(err)
                    }
                }else{
                    try{
                        //var tax_id = sessionStorage.getItem('tax_id')
                        var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
                        var url = '/petty_cash/api/v1/export_report_remaining'
                        let form = {
                            status:this.data,
                            tax_id:tax_id,
                            start_date,
                            end_date
                            }
                        var  data  = await this.axios.post(this.$api_url  + url, form, {responseType:"blob"})
                        .then( response  =>{
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement("a");
                            let namefile = `Performance Report ${moment().locale('th').add(543, 'year').format('DD MMMM YYYY h_mm_ss')}.xlsx`
                            link.href = url;
                            link.setAttribute("download", namefile);
                            document.body.appendChild(link);
                            link.click();
                        })
                    }
                    catch(err){
                        console.log(err)
                    }
                }
            },
            async resend(tranid){
                this.click_resend = true
                try {
                    //console.log("Transaction_id",tranid)
                    var url = '/petty_cash/api/v1/resend'
                    var { data } = await this.axios.post(this.$api_url + url, {
                        transaction_id:tranid
                    })
                    this.dialog = false
        
                } catch (error) {
                    console.log(error);
                }

            },
            submit(){
                try {
                    //----- เช็คเงื่อนไขระหว่างAPI ==> Waiting Performance Status กับ All Document -----//
                    if( this.page_all_document && this.page_waiting){
                        //console.log("All Document");
                        this.getReportItem_Alldoc()
                    }else{
                        //console.log("Page Waiting");
                        this.getReportItem()
                    }
                    this.search=''
                } catch (error) {
                    console.log(error);
                }
            },
            async checkstatusPaid() {
                this.status_green = 0
                this.status_yellow = 0
                this.status_red = 0
                try {
                    if(this.data == 'paid'){
                        //var tax_id = sessionStorage.getItem('tax_id')
                        var tax_id = JSON.parse(sessionStorage.getItem('tax_id'));
                        var url = '/petty_cash/api/v2/count_hc_status_paid'
                        var { data } = await this.axios.post(this.$api_url + url, {
                            status: this.data,
                            tax_id:tax_id,
                            keyword:this.search,
                            start_date:this.date[0],
                            end_date:this.date[1],
                        })
                        if(data){
                            this.status_red = data.resule.red
                            this.status_green = data.resule.green
                            this.status_yellow = data.resule.yellow
                            this.total_status = this.status_red + this.status_green + this.status_yellow
                        }
                        //-------------- Set Percentage --------------//
                        this.Percen_red    = ((this.status_red*100)/this.total_status).toFixed(2)
                        this.Percen_green  = ((this.status_green*100)/this.total_status).toFixed(2)
                        this.Percen_yellow = ((this.status_yellow*100)/this.total_status).toFixed(2)
                    }
                } catch (error) {
                    console.log(error);
                }
            },
            async checkWaitSyncStatus() {
                this.load = true
                this.is_on_job = false
                try{
                    var url = '/petty_cash/api/v1/check_wait_status_queue'
                    var { data } = await this.axios.get(this.$api_url + url)
                    if(data){
                        this.is_on_job = data.result.on_job
                        let syncDate = new Date(data.result.updatedAt)
                        syncDate.setHours(syncDate.getHours() + 7)
                        let sTime = syncDate.toISOString().substr(11,8)
                        let sDate = syncDate.toISOString().substr(0,10)
                        sDate = sDate.split("-")
                        this.sync_date_time = `${sDate[2]}/${sDate[1]}/${Number(sDate[0])+543} ${sTime}`
                    } 
                }catch(error){
                    console.log(error)
                }
                finally{
                    this.load = false
                }
            },
            async checkWaitSync() {
                this.load = true
                try{
                    var url = '/petty_cash/api/v1/check_wait_status'
                    this.is_on_job = true
                    var { data } = await this.axios.get(this.$api_url + url)
                    if(data){

                    } 
                }catch(error){
                    console.log(error)
                }
                finally{
                    this.load = false
                    await this.checkWaitSyncStatus()
                    this.getReportItem_Alldoc()
                }
            },
        },
        //---------------------------- beforeDestroy ----------------------------//
        beforeDestroy() {
            EventBus.$off('formhcdashboarddetailmodal')
        }
    }
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Thai');
.front-text-date-detail{
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important; 
}
.btn-resubmit{
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 12px !important; 
}

.text-hc-content{
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important; 
    color: #219653 !important;
}

.text-hc-already-pay {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important; 
    color: black !important;
}

.status-color-card-block {
    margin-left: 50px;
}

.status-color-card {
    background-color: #EEEEEE !important;
    border-radius: 5px !important;
}

.status-color-icon-block {
    border-radius: 5px !important;
}

.status-color-green-value {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px;
    color: #3FBC3F;
    align-self: end;
}

.status-color-yellow-value {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px;
    color: #FEA322;
    align-self: end;
}

.status-red-card-block {
    padding-top: 0% !important;
    padding-left: 24px !important;
}

.status-color-red-value {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px;
    color: #FF0000;
    align-self: end;
}

.data-status-alert{
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    color: #D1392B !important; 
}
.data-status-moniter{
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    color: #FAAD14 !important;   
}
.data-status-normal{
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    color: #01B901 !important;   
}
.hide-hc-table-progress .v-data-table__progress {
    display: none;
} 

.hc-data-table.v-data-table > .v-data-table__wrapper {
    height: calc(100vh - 296px) !important;
    overflow: auto;
  }  
.theme--light .hc-data-table-border.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row){
    border-bottom: 1px solid #F3F5F7 !important;
}

.hc-data-table-border .v-data-table__wrapper {
    border: 1px solid #F3F5F7;
  }

.hc-data-table-header.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important  ;
    font-weight: 700 !important; 
    color: #333333 !important;
    background: #F3F5F7;
    text-align: center !important;
    height: 40px !important;
    box-shadow: none !important;
  }  
.hc-data-table-table.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
    color: #464646 !important;
    height: 40px !important;
  }  

.card-title-background-detail {
    background: #1DBC97;
    
}
.row-db {
    width: 100%;
    margin: 0% !important;
} 
.front-hc {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important;
    color: #ffffff;
}
.front-text-hc {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 16px !important;
    color: #333333;
}     
.search-box-hc.v-text-field input {
    line-height: 24px !important;
}
.search-box-hc {
    font-family: 'Noto Sans Thai', sans-serif;
    font-size: 14px !important;
}  
.btn-export-excel{
  font-family: 'Noto Sans Thai', sans-serif;
  font-size: 14px !important;
  border-radius: 8px;
  border: 1px solid #E6E6E6 !important;

} 

.between-hc{
    margin-bottom: 1% !important;
}
.black_color{
    color: #333333 !important;
}
@media only screen and (max-width:600px){ /*css for mobile screen*/
.status-color-green-value{
    font-size: 14px !important;
}
.status-color-yellow-value{
    font-size: 14px !important;
}
.status-color-red-value{
   font-size: 14px !important; 
}
.between-btn{
  margin-left: auto !important;

}

.status-color-card-block {
    margin-left: 0px;
} 

.status-red-card-block {
    padding-top: 2% !important;
    padding-left: 0px !important;
}

.status-color-red-value {
    width: 80%;
    text-align: end;
}

.hc-data-table.v-data-table > .v-data-table__wrapper {
    max-height: calc(100vh - 530px) !important;
} 
.between-hc{
    margin-bottom: 0% !important;
} 
}
</style>
